<template>
	<section class="contact">
		<div class="container contact__form_cnt">
			<div class="columns">
				<div class="column col-xl-12">
					<h1>Contact Us</h1>
				</div>
			</div>
			<div class="columns">
				<div class="column col-mx-auto">
					<div class="form_cnt p-relative">
						
						<div class="form_state p-absolute">

							<div class="status">
								<div v-if="submited">
									<ok :width="200"/>
								</div>
								<div v-else class="status__err">
									<error :width="200"/>
								</div>
							</div>

              <div v-if="submited" class="status_text">
								Your message has been sent
							</div>
							<div v-else class="status_text">
								Something went wrong. Pls refresh and resubmit the form 
							</div>

						</div>

						<transition @leave="leave">
							<form v-show="showForm" action="" @submit.prevent="onFormSubmit" class="contact_form p-relative">

								<div class="contact_form__row">
									<label for="name">Name</label><br>
									<input type="text" name="name" id="name" v-model="formData.name">
								</div>

								<div class="contact_form__row">
									<label for="name">Email</label><br>
									<input type="email" name="email" id="email" required v-model="formData.email">
								</div>

								<div class="contact_form__row">
									<label for="message">Message</label><br>
									<textarea id="message" required minlength="5" v-model="formData.message"></textarea>
								</div>
								<div class="contact_form__row">
									<span class="contact_form__capcha">
										<vue-recaptcha
										ref="recaptcha"
										:sitekey="sitekey"
										@verify="onVerify">
										</vue-recaptcha>
									</span>
								</div>
								<div class="contact_form__row p-relative">
									<button type="submit" @click="submitAnim">Send</button>
									<div class="contact_form__loader p-absolute">
	                	<div class="box"></div>
	                </div>
								</div>

							</form>
						</transition>
              
					</div>
				</div>
			</div>
		</div>
		<FooterSection class="footer"/>
	</section>
</template>

<script>
	import FooterSection from '@/components/FooterSection.vue';
	import ok from '@/components/svg_icons/ok.vue';
	import error from '@/components/svg_icons/error.vue';
	import VueRecaptcha from 'vue-recaptcha';

	function getFormData(){
		return{
			name: '',
			email: '',
			massage: ''
		}
	}
	export default {
		name: 'Contact',
		components:{
			FooterSection,
			ok,
			error,
			VueRecaptcha 
		},
		data(){
			return {
				formData: getFormData(),
				showForm: true,
				submited: false,
				submitBtn: null,
				sitekey: '6LePM5wUAAAAAGT2rO6nP6SStl3dI5B2tnA2xYgT',
				verify: false
			}
		},
		methods:{
			onFormSubmit(){
				let button = document.querySelector('button[type="submit"]')

				// display form loader when start to submit form
				let formLoader = new TimelineMax({repeat: -1})
					.to('.contact_form__loader', 0.1, {css: {opacity: 1}, ease: Power0.easeNone})
					.to('.box', 2, {css: {left: '110px'}, ease: Power1.easeInOut})
					.to('.box', 0.2, {css: {opacity: 1}, ease: Power1.easein},"-=1.8")
					.to('.box', 0.6, {css: {width: '8px'}, ease: Power1.easeOut}, "-=1")
					.to('.box', 0.4, {css: {borderRadius: '50%', backgroundColor: '#41354d'}, ease: Power1.easeIn}, "-=0.8")
					.to('.box', 0.2, {css: {opacity: 0}, ease: Power1.easeIn},"-=0.2")
				formLoader.timeScale(1.5)

				const phpForm = 'contact-form';
				let fData = new FormData(),
				options = {
					method: 'POST',
					body: fData
				};
				fData.append('name', this.formData.name);
				fData.append('email', this.formData.email);
				fData.append('message', this.formData.message);
				if((this.formData.email !== '' && this.formData.email !== undefined) 
					&& (this.formData.message !== '' && this.formData.message !== undefined) 
					&& this.verify){
					// disable submit buttom
					button.disabled = true
					this.submitBtn.set(button, {css: {backgroundColor: '#ced4da'}});
					let req = new Request(phpForm, options);
					fetch(req)
						.then((response)=>{
							if(response.ok){
								return response.text();
							}else{
								throw new Error('Bad HTTP'); 
							}
						})
						.then((res)=>{
							console.log(res)
							this.submited = true
							this.showForm = false
							this.formData = getFormData()
							formLoader.pause()
						})
						.catch((err)=>{
							this.submited = false 
							this.showForm = false
							this.verify = false
							formLoader.pause()
						})
					}else{
						formLoader.pause()
					}
			},
			onVerify(res){
				if(res) this.verify = true
			},
			submitAnim(e){
				let button = document.querySelector('button[type="submit"]')
				this.submitBtn = new TimelineLite()
					.to(e.target, 0.2, {css: { backgroundColor: '#41354d', scale: '1.1', boxShadow: '0 0 0 3px rgba(0,0,0,0.5)'}, ease: Power2.easeOut})
					.to(e.target, 0.1, {css: { backgroundColor: '#00BED0', scale: '1', boxShadow: '0 0 0 0 rgba(0,0,0,0.5)'},ease: Power2.easeOut
					})
			},
			leave: function (el, done) {
				new TimelineLite({delay: 0.1, onComplete:()=>{
							done()
						}
					})
					.to(el, 0.3, {css:{opacity: 0, y: 50}, ease: Power0.easeNone })   
					.to('.form_state', 0.6, {css: {opacity: 1, pointerEvents: 'auto', transform: 'translate3d(0%, 0, 0)'}, ease: Power0.easeNone},'-=0.1')
					.to('.status', 0.4, {css: {rotation: 360, color: '#d5ff80'}, ease: Power1.easeInOut}, '-=0.2')
			}
		}
	}
</script>

<style scoped lang="scss">
.contact{
	&__form_cnt{
		min-height: calc(100vh - 342px);
		height: 688px;
		padding-bottom: 101px;
		.form_cnt{
			max-height: 100%;
			margin: 1.5rem 0 60px 0;
			height: 461px;
		}
	}
	h1{
		text-align: center;
		color: $dirty-vel;
	}
	.contact_form{
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		max-width: 600px;
		margin: 0 auto;
		&__row{
			flex: 0 1 600px;
			margin: 0.4rem 0;
		}
		label{
			color: $gray-500;
		}
		input, textarea{
			font-weight: 500;
			font-family: 'Work Sans';
			width: 100%;
			max-width: 600px;
			font-size: 1.2em;
			padding: 0.4rem;
			border: 2px solid $gray-400;
			border-radius: 4px;
			transition: border 0.2s ease-out;
			&:focus{
				outline-width: 0;
				border-color: $pink;
			}
		}
		button[type="submit"]{
			margin-top: 5px;
			font-weight: 500;
			font-family: 'Work Sans';
			font-size: 1.5rem;
			background: $pale-blue;
			color: white;
			border: none;
			border-radius: 4px;
			cursor: pointer;
			padding: 1px 1rem;
			&:focus{
				outline-width: 0;
				border-radius: 4px;
			}
			&:disabled{
				background-color: $gray-300;
			}
		}
		&__loader{
			height: 8px;
			width: 124px;
			right: 0;
			top: 10px;
			opacity: 1;
			overflow: hidden;
			.box{
				position: absolute;
				opacity: 0;
				top: 0px;
				left: 0px;
				width: 30px;
				height: 8px;
				border-radius: 2px;
				background-color: $pale-blue;
			}
		}
	}
	.rotate-enter-active{
		transition: all 1s linear;
		transform: rotate(-360deg);
	}
	.form_state{
		@extend .contact_form;
		height: 100%;
		width: 100%;
		opacity: 0;
		left: 0;
		top: 0;
		transform: translate3d(0, -50%, 0);
		pointer-events: none;
		max-width: 100%;
		color: $dirty-vel;
		.status{
			max-width: 200px;
			max-height: 200px;
			margin-top: 1rem;
			color: $gray-300;
		}
		.status_text{
			flex: 1 1 100%;
			text-align: center;
		}
	}
}
</style>
